<template>
    <dashlet-card :page-tooltip="t_page_tooltip_mediapool"
                  :title="t_title"
                  page-href="/content/mediapool">
        <template #prependButton>
            <square-button :disabled="loading"
                           :loading="loading"
                           :tooltip-text="t_refresh_tooltip"
                           flat
                           icon="far fa-arrows-rotate"
                           @click="fetchUsageData" />
        </template>

        <div class="ibox-content"
             style="border: unset;">
            <disk-usage-meter :quota="quota"
                              :usage="usage"
                              big />
        </div>
    </dashlet-card>
</template>

<script>
import DashletCard from './dashlet-card.vue'
import SquareButton from '../../content/common/squareButton.vue'
import DiskUsageMeter from '../../content/mediapool/disk-usage-meter.vue'

export default {
    components: { SquareButton, DashletCard, DiskUsageMeter },
    data: function() {
        return {
            loading: true,
            quota: undefined,
            usage: undefined,

            t_title: Lang.langGet('Storage utilization'),
            t_page_tooltip_mediapool: Lang.langGet('Mediapool'),
            t_refresh_tooltip: Lang.langGet('Reload'),

            t_of: Lang.langGet('of'),
            t_in_use: Lang.langGet('in use'),
            t_unlimited: Lang.langGet('unlimited storage')
        }
    },
    methods: {
        fetchUsageData() {
            this.loading = true
            axios.get('/dashboard/storage/get').then((response) => {
                this.quota = response.data.quota
                this.usage = response.data.usage
            })/*.catch((error) => {
                if (error.response.status === 401) {
                    window.location = '/login';
                }
            })*/
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {
        this.fetchUsageData()
    }
}
</script>
